import * as React from 'react';
import { wrapDisplayName, compose } from 'recompose';
import { connect } from 'react-redux';

import { makeSelectModalState } from './selectors';
import * as modalActions from './actions';

import MPModal from 'src/components/MPModal';

interface IWithModalConnectedProps {
  isOpen: boolean;
}

interface IWitModalStateDispatchProps {
  closeModal: typeof modalActions.closeModal;
}

export interface IWithModalProps {
  onAfterOpen?: () => void;
  onAfterClose?: () => void;
  className?: string;
}

export interface IWithModalOptions {
  modalName: string;
}

export const withModal = ({ modalName }: IWithModalOptions) => <OriginalProps extends {}>(
  WrappedComponent: React.ComponentType<OriginalProps>,
) => {
  class ModalContainer extends React.Component<
    IWithModalProps & IWithModalConnectedProps & IWitModalStateDispatchProps,
    any
  > {
    public static displayName = wrapDisplayName(WrappedComponent, 'withModal');

    public render(): React.ReactNode {
      const { isOpen, onAfterOpen, onAfterClose, ...props } = this.props;
      return (
        <MPModal
          onRequestClose={this.handleModalClose}
          isOpen={isOpen}
          onAfterOpen={onAfterOpen}
          onAfterClose={onAfterClose}
        >
          <WrappedComponent {...(props as any)} />
        </MPModal>
      );
    }

    private handleModalClose = () => {
      const { closeModal } = this.props;

      closeModal(modalName);
    };
  }

  const enhance = compose(
    connect<IWithModalConnectedProps, IWitModalStateDispatchProps, IWithModalProps>(
      state => {
        return {
          isOpen: makeSelectModalState(modalName)(state),
        };
      },
      modalActions,
    ),
  );

  return enhance(ModalContainer);
};



// WEBPACK FOOTER //
// ./src/modules/modal/withModal.tsx